document.addEventListener('DOMContentLoaded', function () {
    var root = document.getElementById('navDrawer');
    if (!root) return;

    var trigger = document.getElementById('navDrawerTrigger');
    var closeBtn = document.getElementById('navDrawerClose');
    var overlay = document.getElementById('navDrawerOverlay');
    var panel = document.getElementById('navDrawerPanel');
    var focusableSelector = 'a[href], button:not([disabled])';
    var lastFocusedElement = null;

    /* ---- Drawer open/close ---- */
    function openDrawer() {
        lastFocusedElement = document.activeElement;
        panel.classList.add('is-active');
        overlay.classList.add('is-active');
        trigger.setAttribute('aria-expanded', 'true');
        panel.setAttribute('aria-hidden', 'false');
        document.body.classList.add('nav-drawer-open');

        var firstFocusable = panel.querySelector(focusableSelector);
        if (firstFocusable) firstFocusable.focus();

        document.addEventListener('keydown', handleKeydown);
    }

    function closeDrawer() {
        panel.classList.remove('is-active');
        overlay.classList.remove('is-active');
        trigger.setAttribute('aria-expanded', 'false');
        panel.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('nav-drawer-open');

        document.removeEventListener('keydown', handleKeydown);
        if (lastFocusedElement) lastFocusedElement.focus();
    }

    function handleKeydown(e) {
        if (e.key === 'Escape') {
            closeDrawer();
            return;
        }

        if (e.key === 'Tab') {
            var focusables = Array.prototype.slice.call(panel.querySelectorAll(focusableSelector));
            if (!focusables.length) return;

            var first = focusables[0];
            var last = focusables[focusables.length - 1];

            if (e.shiftKey && document.activeElement === first) {
                e.preventDefault();
                last.focus();
            } else if (!e.shiftKey && document.activeElement === last) {
                e.preventDefault();
                first.focus();
            }
        }
    }

    trigger.addEventListener('click', function () {
        var isOpen = trigger.getAttribute('aria-expanded') === 'true';
        if (isOpen) {
            closeDrawer();
        } else {
            openDrawer();
        }
    });

    closeBtn.addEventListener('click', closeDrawer);
    overlay.addEventListener('click', closeDrawer);

    window.addEventListener('resize', function () {
        if (window.innerWidth >= 990 && trigger.getAttribute('aria-expanded') === 'true') {
            closeDrawer();
        }
    });

    /* ---- Submenu accordion (slide down) ---- */
    var expandButtons = Array.prototype.slice.call(panel.querySelectorAll('.nav-drawer__expand'));

    expandButtons.forEach(function (btn) {
        var item = btn.closest('.nav-drawer__item');
        var submenu = item.querySelector('.nav-drawer__submenu');
        var sublist = submenu.querySelector('.nav-drawer__sublist');

        btn.addEventListener('click', function () {
            var isOpen = item.classList.contains('is-open');

            if (isOpen) {
                submenu.style.height = sublist.offsetHeight + 'px';
                requestAnimationFrame(function () {
                    submenu.style.height = '0px';
                });
                item.classList.remove('is-open');
                btn.setAttribute('aria-expanded', 'false');
            } else {
                submenu.style.height = sublist.offsetHeight + 'px';
                item.classList.add('is-open');
                btn.setAttribute('aria-expanded', 'true');

                submenu.addEventListener('transitionend', function handler() {
                    if (item.classList.contains('is-open')) {
                        submenu.style.height = 'auto';
                    }
                    submenu.removeEventListener('transitionend', handler);
                });
            }
        });
    });

    /* Recalculate open submenu heights on resize */
    window.addEventListener('resize', function () {
        var openItems = panel.querySelectorAll('.nav-drawer__item.is-open');
        openItems.forEach(function (item) {
            var submenu = item.querySelector('.nav-drawer__submenu');
            var sublist = submenu.querySelector('.nav-drawer__sublist');
            submenu.style.height = sublist.offsetHeight + 'px';
        });
    });

    /* Close drawer entirely when a leaf link (not the expand arrow) is clicked */
    var leafLinks = panel.querySelectorAll('.nav-drawer__link, .nav-drawer__subitem a');
    leafLinks.forEach(function (link) {
        link.addEventListener('click', function () {
            closeDrawer();
        });
    });
});